import './bootstrap'

import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const appEl = document.querySelector('#app') as HTMLElement
const VITE_SENTRY_VUE_DSN = import.meta.env.VITE_SENTRY_VUE_DSN

const pinia = createPinia()

const app = createApp(App, { ...appEl.dataset })

if (import.meta.env.PROD) {
    Sentry.init({
        app,
        dsn: VITE_SENTRY_VUE_DSN,
        sendDefaultPii: false,
        enableLogs: true,

        // 1. SMART SAMPLING (Start of Request)
        // Decide IF we should even try to record this session.
        tracesSampler: (samplingContext) => {
            // A. Ignore Health Checks / Heartbeats completely (0% sample rate)
            if (samplingContext.transactionContext.name === 'GET /health-check') {
                return 0.0
            }

            // B. Ignore common bot/crawler traffic
            if (
                samplingContext.request &&
                samplingContext.request.headers &&
                samplingContext.request.headers['user-agent'] &&
                samplingContext.request.headers['user-agent'].includes('Googlebot')
            ) {
                return 0.0
            }

            // // C. Boost sampling for critical paths (e.g., Checkout) to 100%
            // if (samplingContext.transactionContext.name === 'POST /checkout') {
            //     return 1.0
            // }

            // D. Default fall-back rate for everything else (e.g., 10%)
            return 0.1
        },

        // 2. THE QUOTA SAVER (End of Request)
        // The transaction is finished. Now we decide if we actually send it to Sentry.
        beforeSendTransaction(event) {
            // Check if the transaction status is 'ok' (successful)
            // Sentry typically marks successful transactions with status: 'ok'
            if (event.contexts?.trace?.status === 'ok') {
                const start = event.start_timestamp
                const end = event.timestamp

                // Keep it anyway if it was notably slow (> 2 seconds)
                if (start && end && end - start > 2) {
                    return event
                }

                // Drop the successful transaction to save quota
                return null
            }

            // If status is NOT 'ok' (error, cancelled, unknown), send it!
            return event
        },
    })
}

app.use(pinia)
app.use(router)
app.mount(appEl)
